import { PaymentInstrument } from "./types";

export default function PaymentMethodList({
  paymentInstruments,
  onSetDefault,
  settingDefaultId,
}: {
  paymentInstruments: PaymentInstrument[];
  onSetDefault: (p: PaymentInstrument) => void;
  settingDefaultId: string | null;
}) {
  const sorted = [...paymentInstruments].sort((a, b) => Number(!!b.isDefault) - Number(!!a.isDefault));

  return (
    <div className="flex gap-4 flex-wrap mb-6">
      {sorted.map((p, index) => (
        <div
          key={index}
          onClick={() => onSetDefault(p)}
          className={`group border rounded-lg px-5 py-4 w-72 text-sm transition-all duration-200 ease-in-out bg-white ${
            p.isDefault ? "border-green-400" : "border-gray-200 hover:border-blue-500 cursor-pointer"
          }`}
        >
          <div className="space-y-1">
            <div className="text-gray-500 text-xs uppercase tracking-wide flex items-center gap-2">
              <span>Bank Account</span>
              {p.isDefault ? (
                <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-[10px] font-semibold normal-case">
                  Default
                </span>
              ) : null}
            </div>
            <div className="text-gray-900 font-medium">
              •••• {p.lastFour}
            </div>
            {!p.isDefault ? (
              <div className="text-xs text-gray-400">
                {settingDefaultId === p.id ? "Updating..." : "Click to set default"}
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}
